export default __webpack_public_path__ + "static/media/Lato-BoldItalic.0904b382.woff2";